import PlayerDetail from './PlayerDetail';

export default PlayerDetail;
